const getStoreFrom = (storage: Storage) => ({
  set: (name: string, value: object | string | boolean | number) =>
    storage.setItem(name, JSON.stringify(value)),
  get: (name: string) => {
    const value = storage.getItem(name);
    try {
      return value && JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  remove: (name: string) => storage.removeItem(name),
  clear: () => storage.clear(),
});

export const sessionStore = getStoreFrom(sessionStorage);
export const localStore = getStoreFrom(localStorage);
